import React from 'react';
import { Flex, Box } from 'grid-styled';
import pure from 'recompose/pure';

/* UI */
import CircularProgress from 'material-ui/CircularProgress';

/* Styles */
import hopeTheme from '../../../styles/themes/hopeTheme';

const Loader = ({ loaderPadding }) => (
  <Flex
    column
    align="center"
    justify="center"
    style={{
      paddingBottom: loaderPadding ? `${loaderPadding - 2}%` : '40%',
      paddingTop: loaderPadding ? `${loaderPadding - 2}%` : '40%',
    }}
  >
    <Box>
      <CircularProgress
        color={hopeTheme.hopeLightPurple}
        size={27.75}
        thickness={1.75}
      />
    </Box>
  </Flex>
);

export default pure(Loader);
